module.exports = __webpack_public_path__ + "assets/icon_cloud_visit_defalut.2a12475a.svg";